/**
 * NotificationPayVideoKind
 *
 * The four pay/boost-video notification sub-types rendered by
 * `NotificationPayVideoItem`. Web-local discriminant (no Flutter enum to
 * ordinal-match); string-valued for clearer debugging, mirroring
 * `inboxItemType.ts`. Per `conventions.md` § "Enums live in the domain layer",
 * it lives in the domain layer even though its first consumer is
 * presentation-local.
 */
export enum NotificationPayVideoKind {
  payPremiumVideo = 'payPremiumVideo',
  payPremiumVideoFailed = 'payPremiumVideoFailed',
  payBoostVideo = 'payBoostVideo',
  payBoostVideoFailed = 'payBoostVideoFailed',
}
